<script>
  import {Bar, mixins} from 'vue-chartjs'
  import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
  // import the component - chart you need

  // Extend it
  //labelListOriginal will hold the original value that was parsed to prettier value in labelListOriginal. For example if labelList[3] is '5 March 2021', labelListOriginal should be 20210305
  export default {
    extends: Bar,
    props: ['dataTitle','behaviorID','behaviorName','behaviorColor','labelList','dataList',"duration","startDate","endDate","year","category","labelListOriginal"],
    data() {
        var _this = this;
        return {
            datacollection: {
                labels: this.labelList,
                datasets: [
                    {
                        label: this.dataTitle,
                        backgroundColor: this.behaviorColor,
                        data: this.dataList
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: 'bottom'
                },                
                scales: {
                    xAxes: [{
                        ticks: {
                            autoSkip: false,
                            maxRotation: 90,
                            minRotation: 90
                        }
                    }]
                },
                plugins: {
                    datalabels: {
                        anchor: 'end',
                        align: 'start',
                        formatter: Math.round,
                        font: {
                            weight: 'bold'
                        }
                    }
                },
                onClick: function(evt,arr) {
                    var selectedLabelColumn;
                    var selectedLabelColumnTitle;
                    this.getElementsAtEventForMode(evt, "y", 1).forEach(function(item) { selectedLabelColumn = item._index; selectedLabelColumnTitle = item['_model']['label']; });
                    //alert("Column " + selectedLabelColumn + " was selected");

                    try{
                        var label = arr[0]['_model'].label  //this line is purely to throw error for empty bar
                        _this.graphClickEvent(evt,arr);
                    }catch(err){
                        _this.viewBarDetails(selectedLabelColumn,selectedLabelColumnTitle)
                    }            
                }
            }
        }
    },
    methods: {
        graphClickEvent(evt,arr){
            var label = arr[0]['_model'].label
            var index = arr[0]['_index']
            console.log("entering graphClickEvent with index: " + index + " and label: " + label)

            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_ID',this.behaviorID)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_NAME',this.behaviorName)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_CATEGORY',this.category)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION',this.duration)
            this.$store.commit('UPDATE_START_DATE',this.startDate)
            this.$store.commit('UPDATE_END_DATE',this.endDate)
            this.$store.commit('UPDATE_YEAR',this.year)
            this.$store.commit('UPDATE_ACTION_DATE',this.labelListOriginal[index])

            localStorage.setItem('VIEW_SUBMISSIONS_BEHAVIOR_ID',this.behaviorID)
            localStorage.setItem('VIEW_SUBMISSIONS_BEHAVIOR_NAME',this.behaviorName)
            localStorage.setItem('VIEW_SUBMISSIONS_CATEGORY',this.category)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION',this.duration)
            localStorage.setItem('START_DATE',this.startDate)
            localStorage.setItem('END_DATE',this.endDate)
            localStorage.setItem('YEAR',this.year)
            localStorage.setItem('ACTION_DATE',this.labelListOriginal[index])

            console.log("85 pushing this.behaviorID: " + this.behaviorID)
            console.log("85 pushing this.behaviorName: " + this.behaviorName)
            console.log("85 pushing this.category: " + this.category)
            console.log("85 pushing this.duration: " + this.duration)
            console.log("85 pushing this.startDate: " + this.startDate)
            console.log("85 pushing this.endDate: " + this.endDate)
            console.log("85 pushing this.year: " + this.year)
            console.log("85 pushing this.actionDate: " + this.labelListOriginal[index])

            // this.$router.push({
            //     name: "SubmissionDetails"
            // });
        },
        viewBarDetails(index,title){
            console.log("entering viewBarDetails with index: " + index + " and title: " + title)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_ID',this.behaviorID)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_BEHAVIOR_NAME',this.behaviorName)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_CATEGORY',this.category)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION',this.duration)
            this.$store.commit('UPDATE_START_DATE',this.startDate)
            this.$store.commit('UPDATE_END_DATE',this.endDate)
            this.$store.commit('UPDATE_YEAR',this.year)
            this.$store.commit('UPDATE_ACTION_DATE',this.labelListOriginal[index])

            localStorage.setItem('VIEW_SUBMISSIONS_BEHAVIOR_ID',this.behaviorID)
            localStorage.setItem('VIEW_SUBMISSIONS_BEHAVIOR_NAME',this.behaviorName)
            localStorage.setItem('VIEW_SUBMISSIONS_CATEGORY',this.category)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION',this.duration)
            localStorage.setItem('START_DATE',this.startDate)
            localStorage.setItem('END_DATE',this.endDate)
            localStorage.setItem('YEAR',this.year)
            localStorage.setItem('ACTION_DATE',this.labelListOriginal[index])

            // this.$router.push({
            //     name: "SubmissionDetails"
            // });
        }
    },
    mounted () {
        
    this.addPlugin({
        id: 'ChartJsPluginDataLabels',
    //     beforeInit: function (chart) {
    //   ....
    //     }
    })
      // Overwriting base render method with actual data and options
      this.renderChart(this.datacollection, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Charts/BarChart.vue